import {
  visitsDomain,
  partnersDomain,
  payerDomain as aggregatorsDomain,
} from '../../Common/constants';

export const visitsUrl = `${visitsDomain}/visit-submitted/`;

export const visitsDetailsUrl = `${visitsDomain}/visit/`;

export const partnersUrl = `${partnersDomain}/partner/`;

export const agenciesUrl = `${partnersDomain}/agency/`;

export const aggregatorsUrl = `${aggregatorsDomain}/aggregators/`;

export const extraSmallContent = 'extraSmallContent';
export const smallContent = 'smallContent';
export const mediumContent = 'mediumContent';
export const largeContent = 'largeContent';
